export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.2-1425.23",
  commitId: "a822376396b9e081aeef73112d6aa8b47e277dd4",
  commitTime: "2026-04-02T14:25:23.000Z",
});
